import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { UsersPage } from '@/areas/settings/Settings/UsersPage/UsersPage';
import { canViewUserManagementUsers } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/users/')({
    staticData: { access: { permissions: canViewUserManagementUsers }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <UsersPage />;
}
